import { Injectable } from '@angular/core';
import { AppSettings } from '../providers/app-settings';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

@Injectable()
export class AssetsService {
  private assetsApiUrl: string;

  constructor(public http: Http, private appSettings: AppSettings) {
    this.assetsApiUrl = this.appSettings.DB_API_ENDPOINT + 'assets/';
  }

  private getDataInJson(res: Response) {
    return res.json();
  }

  public getAllAssets(): Promise<Array<any>> {
    return  this.http.get(this.assetsApiUrl, this.appSettings.apiOptions)
                .toPromise()
                .then(this.getDataInJson);
  }

  public addAsset(assetLabel: string, base64EncodedFile: string, mimeType: string, fileExtension: string): Observable<any> {
    return  this.http.post(this.assetsApiUrl, {
      label: assetLabel,
      type: mimeType,
      base64EncodedFile: base64EncodedFile,
      fileExtension: fileExtension,
    }, this.appSettings.apiOptions)
                .map(this.getDataInJson);
  }

  public delAsset(id): Observable<any> {
    return this.http.delete(this.assetsApiUrl + id, this.appSettings.apiOptions);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/services/assets.service.ts